import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/Home/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { Users, Billing } from '../pages/Accounts/'
import { CloudSecurityMain } from '../pages/CloudSecurity'
import { Support } from '../pages/Support/Support'
import { Tickets } from '../pages/Support/Tickets'
import { TroubleshootingPage } from '../pages/ctx-hub/2_Troubleshooting/Troubleshooting'
import { DataTransfer } from '../pages/ctx-hub/1_DataUsage/DataTransfer'
import { Roles } from '../pages/Accounts/roles'
import { Features } from '../pages/Accounts/Features'
import { useAuth } from '../modules/auth'
import { SolicitarnuevoCTXh } from '../modules/custom/newctxForm/NewCtx'
import { NewCTX } from '../pages/NewCtxRequest/tableNewCTX'
import { AddBGPSEGMENTS } from '../pages/ctx-hub/3_BGPSegment/bgpsegment'
import { AddIpsecGMENTS } from '../pages/ctx-hub/4_IPSECSegment/iPSECgment'
import { Register } from '../pages/ctx-R/register'
import { Neighborstab } from '../pages/ctx-R/Neighbors'
import { TroubleshootingCTXR } from '../pages/ctx-R/Troubleshooting'
import { MonitoringModule } from '../pages/ctx-hub/5_Monitoring/Monitoring'
import { FortiDevices } from '../pages/ctx-hub/Fortinet/Devices_forti'
import { FortiEntitlement } from '../pages/ctx-hub/Fortinet/Entitle_forti'
import { Edge } from '../pages/ctx-services/edge'
import { useAppSelector } from '../../redux/hooks'
import { ConnectorEdg } from '../pages/ctx-hub/6_EdgeConnector/EdgConnector'
import { UserLogs } from '../pages/UserLogs/UserLogs'
import { TablesStatuses } from '../pages/ctx-R/Statuses'
import { Reporting } from '../pages/ctx-R/Reporting'
import ProblemReport from '../modules/custom/supports/components/ChangeReport'
import HelpRequest from '../modules/custom/supports/components/ProblemReport';
import FeatureRequest from '../modules/custom/supports/components/FeatureRequest';
import HelppRequest from '../modules/custom/supports/components/HelpRequest';
import RedirectingPage from '../../app/routing/RedirectingPage';



import LicenseCrud from '../modules/ctr-r/license/licenseTable'
import LicenseInfo from '../modules/ctr-r/LicenseClient/LicenceInfo'
import { SSO } from '../pages/Accounts/SSO'
import { Tenants } from '../pages/Accounts/Tenants'
const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  // const ProblemReport = lazy(() => import('../modules/custom/supports/components/ChangeReport'))
  // const HelpRequest = lazy(() => import('../modules/custom/supports/components/ProblemReport'))
  // const FeatureRequest = lazy(() => import('../modules/custom/supports/components/FeatureRequest'))
  // const HelppRequest = lazy(() => import('../modules/custom/supports/components/HelpRequest'))
  const Add = lazy(() => import('../modules/custom/tickets/Add'))
  const Description = lazy(() => import('../modules/custom/tickets/Description'))

  //const FactuAws = lazy (() => import('../modules/facturacion/FactuAws'))
  const { currentUser } = useAuth()
  const TenantId = useAppSelector(state => state.TenantSlice.id)
  const storedTenant = localStorage.getItem('tenantId')
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
  const isTenantId4 = TenantId === 4 || storedTenant === "4"

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}

        <Route
          path='auth/*'
          element={
            isTenantId4 ? (
              <Navigate to='/cloudConnectivity' />
            ) : (
              <Navigate to='/dashboard' />
            )
          }
        />

        {/* Pages */}

        {
          (currentUser?.ListPermiso?.includes('Home.Status') || currentUser?.ListPermiso?.includes('Home.DataUsage') || currentUser?.ListPermiso?.includes('Home.Networking') || currentUser?.ListPermiso?.includes('Home.Topology')) ?

            <Route path='dashboard/*' element={<DashboardWrapper />} /> :
            <Route path='dashboard' element={<Navigate to='/CTX/datatransfer' />} />
        }

        {/* Lazy Modules */}
        {/*<Route
          path='facturacion/*'
          element={
            <SuspensedView>
              <FactuAws />
            </SuspensedView>
          }
        />*/}



        {/* Accounts Module */}



        {
          currentUser?.ListPermiso?.includes('Ctx.DataUsage') ?
            <Route
              path='CTX/datatransfer'
              element={
                <SuspensedView>
                  <DataTransfer />
                </SuspensedView>
              }
            /> :
            <Route path='CTX/datatransfer' element={<Navigate to='/CTX/troubleshooting' />} />
        }

        {
          (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping') ||
            currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Traceroute') ||
            currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP') ||
            currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS') ||
            currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP')) ? (
            <Route
              path='CTX/troubleshooting/*'
              element={
                <SuspensedView>
                  <TroubleshootingPage />
                </SuspensedView>
              }
            />
          ) : (
            <Route path='CTX/troubleshooting/*' element={<Navigate to='/CTX/addBPGSegment' />} />
          )
        }

        {

          (currentUser?.ListPermiso?.includes('Ctx.BGP.Add') || currentUser?.ListPermiso?.includes('Ctx.BGP.List') || currentUser?.ListPermiso?.includes('Ctx.BGP.Delete'))
            ? <Route
              path='CTX/addBPGSegment'
              element={
                <SuspensedView>
                  <AddBGPSEGMENTS />
                </SuspensedView>
              }
            /> :
            <Route path='CTX/addBPGSegment' element={<Navigate to='/CTX/addIPSecSegment' />} />

        }

        {
          (currentUser?.ListPermiso?.includes('Ctx.IPSEC.List') || currentUser?.ListPermiso?.includes('Ctx.IPSEC.Add') || currentUser?.ListPermiso?.includes('Ctx.IPSEC.Delete'))
            ? <Route
              path='CTX/addIPSecSegment'
              element={
                <SuspensedView>
                  <AddIpsecGMENTS />
                </SuspensedView>
              }
            /> :
            <Route path='CTX/addIPSecSegment' element={<Navigate to='/CTX/monitoring' />} />

        }
        {
          currentUser?.ListPermiso?.includes('Ctx.Monitoring.View') ?
            <Route
              path='CTX/monitoring/*'
              element={
                <SuspensedView>
                  <MonitoringModule />
                </SuspensedView>
              }></Route> :
            <Route path='CTX/monitoring' element={<Navigate to='/cloudConnectivity' />} />
        }
        {
          currentUser?.ListPermiso?.includes('CC.View') ?
            <Route
              path='cloudConnectivity/*'
              element={
                <SuspensedView>
                  <Edge />
                </SuspensedView>
              }></Route> :
            <Route path='cloudConnectivity' element={<Navigate to='/CTX/EdgeConnector' />} />
        }
        {/*  {
          currentUser?.ListPermiso?.includes('CC.View') ? (
            <Route
              path='cloudConnectivity/*'
              element={
                <SuspensedView>
                  <Edge />
                </SuspensedView>
              }
            />
          ) : (
            <Route
              path='cloudConnectivity'
              element={<Navigate to='cloudConnectivity/' />}
            />
          )
        }*/}
        {/* {
          currentUser?.ListPermiso?.includes('Ctx.BGP.Add') && (
            <Route
              path='cloudConnectivity/*'
              element={
                <SuspensedView>
                  <Edge />
                </SuspensedView>
              }
            />
          )
        } */}
        {/**************************************************************************** */}
        {
          (currentUser?.ListPermiso?.includes('Ctx.IPSEC.List') || currentUser?.ListPermiso?.includes('Ctx.IPSEC.Add') || currentUser?.ListPermiso?.includes('Ctx.IPSEC.Delete'))
            ? <Route
              path='CTX/EdgeConnector'
              element={
                <SuspensedView>
                  <ConnectorEdg />
                </SuspensedView>
              }
            /> :
            <Route path='CTX/EdgeConnector' element={<Navigate to='/CTX/Fortinet/FortinetDevices' />} />

        }
        {/************************************************************************************* */}



        {
          (currentUser?.ListPermiso?.includes('Ctx.NGFW.List')
            || currentUser?.ListPermiso?.includes('Ctx.NGFW.Add')
            || currentUser?.ListPermiso?.includes('Ctx.NGFW.Update')
            || currentUser?.ListPermiso?.includes('Ctx.NGFW.Delete')
          ) ?
            <Route
              path='CTX/Fortinet/FortinetDevices'
              element={
                <SuspensedView>
                  <FortiDevices />
                </SuspensedView>
              }
            /> :
            <Route path='CTX/Fortinet/FortinetDevices' element={<Navigate to='/CTX/Fortinet/Entitlement' />} />
        }

        {
          currentUser?.ListPermiso?.includes('Ctx.NGFW.Entitlement.List') ?
            <Route
              path='CTX/Fortinet/Entitlement'
              element={
                <SuspensedView>
                  <FortiEntitlement />
                </SuspensedView>
              }
            /> :
            <Route path='CTX/Fortinet/Entitlement' element={<Navigate to='/CTX-R/status' />} />

        }

        {/* End Accounts Module */}

        {/*Nuevo CTX formukario*/}
        <Route
          path='CTX/newctxrequest'
          element={
            <SuspensedView>
              <SolicitarnuevoCTXh />
            </SuspensedView>
          }
        />
        <Route
          path='CTX/listrequest'
          element={
            <SuspensedView>
              <NewCTX />
            </SuspensedView>
          }
        />

        {/*Nuevo CTX formukario*/}

        {/* Cloud Monitoring Module 
        <Route
            path='CTX/monitoring'
            element={ 
            <SuspensedView>
              <CloudMonitoringMain />
            </SuspensedView> }
            />
         End Cloud Monitoring Module */}


        {/* Cloud Monitoring Module 
        <Route
            path='/documentation'
            element={ 
              <CloudDocumentation />
             }
            />
         End Cloud Monitoring Module */}


        {/* CTX-R Routes */}


        {currentUser?.ListPermiso?.includes("CTXR.GeneralStatus") ?
          <Route
            path='CTX-R/status'
            element={
              <SuspensedView>
                <TablesStatuses />
              </SuspensedView>
            }
          /> : <Route path='CTX-R/status' element={<Navigate to='/CTX-R/visibility' />} />
        }

        {
          (currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.Status') ||
            currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')) ?
            <Route
              path='CTX-R/visibility/*'
              element={
                <SuspensedView>
                  <TroubleshootingCTXR />
                </SuspensedView>
              }
            /> :
            <Route path='CTX-R/visibility' element={<Navigate to='/CTX-R/Management/CreateLicense' />} />
        }

        {
          currentUser?.ListPermiso?.includes("Tenant.list") ?
            <Route
              path='CTX-R/Management/CreateLicense'
              element={
                <SuspensedView>
                  <LicenseCrud />
                </SuspensedView>
              }
            /> : <Route path='CTX-R/Management/CreateLicense' element={<Navigate to='/CTX-R/Management/License' />} />
        }

        {
          currentUser?.ListPermiso?.includes('CTXR.License') ?
            <Route
              path='CTX-R/Management/License'
              element={
                <SuspensedView>
                  <LicenseInfo />
                </SuspensedView>
              }
            /> : <Route path='CTX-R/Management/License' element={<Navigate to='/CTX-R/Management/Instances' />} />
        }

        {
          (currentUser?.ListPermiso?.includes('CTXR.List') || currentUser?.ListPermiso?.includes('CTXR.Cluster.List') || currentUser?.ListPermiso?.includes('CTXR.Cluster.Add')
            || currentUser?.ListPermiso?.includes('CTXR.Cluster.Edit') || currentUser?.ListPermiso?.includes('CTXR.Cluster.Delete')) ?
            <Route path='CTX-R/Management/Instances/*' element={<SuspensedView><Register /></SuspensedView>} /> :
            <Route path='CTX-R/Management/Instances' element={<Navigate to='/CTX-R/Management/neighbors' />} />
        }

        {

          (currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add')
            || currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') || currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') ||
            currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')) ?
            <Route
              path='CTX-R/Management/neighbors/*'
              element={
                <SuspensedView>
                  <Neighborstab />
                </SuspensedView>
              }
            /> :
            <Route path='CTX-R/Management/neighbors' element={<Navigate to='/accounts/billing' />} />
        }

        {

          (currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add')
            || currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') || currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') ||
            currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')) ?
            <Route
              path='CTX-R/Management/reporting/*'
              element={
                <SuspensedView>
                  <Reporting />
                </SuspensedView>
              }
            /> :
            <Route path='CTX-R/Management/reporting ' element={<Navigate to='/accounts/billing' />} />
        }

        {/* Accounts Routes*/}
        {
          currentUser?.ListPermiso?.includes('Accounts.Billing') ?
            <Route
              path='accounts/billing'
              element={
                <SuspensedView>
                  <Billing />
                </SuspensedView>
              }
            /> :
            <Route path='accounts/billing' element={<Navigate to='/accounts/users' />} />
        }

        {
          (currentUser?.ListPermiso?.includes('User.Create') || currentUser?.ListPermiso?.includes('User.List') || currentUser?.ListPermiso?.includes('User.Update') || currentUser?.ListPermiso?.includes('User.Delete')) ?
            <Route
              path='accounts/users'
              element={
                <SuspensedView>
                  <Users />
                </SuspensedView>
              }
            /> :
            <Route path='accounts/users' element={<Navigate to='/accounts/roles' />} />
        }
        {
          (currentUser?.ListPermiso?.includes('User.Create') || currentUser?.ListPermiso?.includes('User.List') || currentUser?.ListPermiso?.includes('User.Update') || currentUser?.ListPermiso?.includes('User.Delete')) ?
            <Route
              path='accounts/SSO'
              element={
                <SuspensedView>
                  <SSO />
                </SuspensedView>
              }
            /> :
            <Route path='accounts/users' element={<Navigate to='/accounts/roles' />} />
        }
        {
          (currentUser?.ListPermiso?.includes('User.Create') || currentUser?.ListPermiso?.includes('User.List') || currentUser?.ListPermiso?.includes('User.Update') || currentUser?.ListPermiso?.includes('User.Delete')) ?
            <Route
              path='accounts/Tenants'
              element={
                <SuspensedView>
                  <Tenants />
                </SuspensedView>
              }
            /> :
            <Route path='accounts/users' element={<Navigate to='/accounts/roles' />} />
        }
        {
          (currentUser?.ListPermiso?.includes('Roles.Create') || currentUser?.ListPermiso?.includes('Roles.List') || currentUser?.ListPermiso?.includes('Roles.Update') || currentUser?.ListPermiso?.includes('Roles.Delete')) ?
            <Route
              path='accounts/roles'
              element={
                <SuspensedView>
                  <Roles />
                </SuspensedView>
              }
            /> :
            <Route path='accounts/roles' element={<Navigate to='/accounts/activitylogs' />} />
        }

        {
          currentUser?.ListPermiso?.includes("Tenant.list") ? (
            <Route
              path='accounts/subscriptions'
              element={
                <SuspensedView>
                  <Features />
                </SuspensedView>
              }
            />
          ) : (
            <Route path='accounts/subscriptions' element={<Navigate to='/CTX-R/Management/License' />} />
          )
        }

        {(currentUser?.ListPermiso?.includes("Accounts.ActivityLog")) ?
          <Route
            path='accounts/activitylogs'
            element={
              <SuspensedView>
                <UserLogs />
              </SuspensedView>
            }
          /> :
          <Route path='accounts/activitylogs' element={<Navigate to='/support/OpenRequest' />} />

        }



        {/* Cloud Monitoring Module */}
        {currentUser?.ListPermiso?.includes('CSP.View') ?
          <Route
            path='/cspm'
            element={
              <SuspensedView>
                <CloudSecurityMain />
              </SuspensedView>}
          /> :
          <Route path='/cspm' element={<Navigate to='/support/OpenRequest' />} />
        }
        {/* End Cloud Monitoring Module */}

        {/* Support Module */}
        {currentUser?.ListPermiso?.includes('Support.Create') ?
          <Route
            path='support/OpenRequest'
            element={
              <SuspensedView>
                <Support />
              </SuspensedView>}
          /> :
          <Route path='support/OpenRequest' element={<Navigate to='/support/SeeRequest' />} />
        }
        {/* End Support Module */}


        {/* Support Module */}
        <Route
          path='changerequest'
          element={
            <SuspensedView>
              <ProblemReport />
            </SuspensedView>}
        />
        {/* End Support Module */}

        <Route
          path='problemreport'
          element={
            <SuspensedView>
              <HelpRequest />
            </SuspensedView>}
        />
        {/* End Support Module */}
        <Route
          path='featurerequest'
          element={
            <SuspensedView>
              <FeatureRequest />
            </SuspensedView>}
        />

        <Route
          path='helprequest'
          element={
            <SuspensedView>
              <HelppRequest />
            </SuspensedView>}
        />
        {/* End Support Module */}


        {/* End Support Module */}

        {/* Support Module */}
        {(currentUser?.ListPermiso?.includes('Support.List') || currentUser?.ListPermiso?.includes('Support.Update')) &&
          <Route
            path='support/SeeRequest'
            element={
              <SuspensedView>
                <Tickets />
              </SuspensedView>}
          />
        }
        {/* End Support Module */}

        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/*************************************************************************/}
        <Route path='create' element={<Add />}></Route>
        <Route path='description/:id' element={<Description />}></Route>


        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/auth' />} />
        <Route path="/redirecting" element={<RedirectingPage />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
